import { SET_COMMODITY_ROWS, ADD_COMMODITY_ROW, UPDATE_COMMODITY_ROWS } from 'Action/types';

const initialState = {
  commodityFieldRows: [
    {
      hsHeader: '',
      descriptionOfGoods: '',
      productId: '',
      itemSupplier: '',
      gtin: '',
      netWeight: '',
      volume: '',
      numberofUnits: '',
      universalUnit: '',
      validFrom: '',
      validUntil: '',
      producerAccordions: [
        {
          producerRows: [{ producerName: '', producerCountry: '' }],
          productionPlaceRows: [
            {
              productionPlace: '',
              type: '',
              coordinates: '',
              area: '',
              harvestValidFrom: '',
              harvestValidTo: '',
              id: null,
            },
          ],
        },
      ],
    },
  ],
};

const commodityStateReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMMODITY_ROWS:
      return {
        ...state,
        commodityFieldRows: action.payload,
      };
    case ADD_COMMODITY_ROW:
      return {
        ...state,
        commodityFieldRows: [...state.commodityFieldRows, action.payload],
      };
    case UPDATE_COMMODITY_ROWS:
      return {
        ...state,
        commodityFieldRows: action.payload,
      };
    default:
      return state;
  }
};

export default commodityStateReducer;
